/* import __COLOCATED_TEMPLATE__ from './posting-feedback.hbs'; */
import { readOnly } from '@ember/object/computed';
import { inject as service } from '@ember/service';
import Component from '@ember/component';
import { closeModal } from "sh-www/utils/modal-controls";

/** @module */
const PostingFeedbackModal = Component.extend({
  tagName: '',

  /** @type {Ember.Service} */
  assignmentCommandService : service('commands/assignment-commands'),
  session: service(),
  assignmentRateType: readOnly('model.assignment.rateType'),

  /** @inheritDoc */
  actions: {
    /**
     * @param {Object} formFields
     * @return {Promise<*>}
     */
    submitFeedback(formFields) {
      const notInterested = Object.values(formFields).some(Boolean);

      return this.assignmentCommandService.setNotInterested(
        this.model.assignment,
        this.session.currentUser.id,
        formFields,
        notInterested,
      ).then(() => {
        this.model.confirmAction?.();
        closeModal(this);
      });
    },

    /**
     *
     */
    close() {
      closeModal(this);
    },
  },
});

export default PostingFeedbackModal;
